import { Clip } from "./clip";

export class ImportClipsRequest {
  shareId: number | null = 0;
  clips: Clip[] | null = null;

  constructor(init?: Partial<ImportClipsRequest>) {
    Object.assign(this, init);
  }
}
